(() => {
  const mobile=window.matchMedia('(max-width:749px)');
  function setup(section){
    if(section.dataset.lcC70Ready)return;
    const rail=section.querySelector('.lc-c70-wearing__rail'),cards=[...section.querySelectorAll('.lc-c70-wearing__card')],controls=section.querySelector('.lc-c70-wearing__controls'),prev=section.querySelector('[data-lc-c70-prev]'),next=section.querySelector('[data-lc-c70-next]'),stage=section.querySelector('.lc-c70-wearing__stage');
    if(!rail||!cards.length||!controls||!prev||!next)return;
    section.dataset.lcC70Ready='true';
    const position=card=>card.getBoundingClientRect().left-rail.getBoundingClientRect().left+rail.scrollLeft;
    const index=()=>cards.reduce((best,card,i)=>Math.abs(position(card)-rail.scrollLeft)<Math.abs(position(cards[best])-rail.scrollLeft)?i:best,0);
    function update(){
      controls.hidden=!mobile.matches||cards.length<2;
      if(controls.hidden)return;
      const i=index(),photo=cards[i].querySelector('.lc-c70-wearing__photo'),r=photo.getBoundingClientRect(),s=stage.getBoundingClientRect();
      const top=r.top-s.top+r.height/2-22;
      prev.hidden=i===0;next.hidden=i===cards.length-1;
      prev.style.top=next.style.top=top+'px';prev.style.left='10px';
      next.style.left=Math.max(10,Math.min(rail.clientWidth-54,r.right-s.left-54))+'px';
    }
    function go(delta){const i=Math.max(0,Math.min(cards.length-1,index()+delta));rail.scrollTo({left:position(cards[i]),behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});}
    prev.addEventListener('click',()=>go(-1));next.addEventListener('click',()=>go(1));
    rail.addEventListener('keydown',e=>{if(e.target!==rail||!mobile.matches)return;if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();go(e.key==='ArrowRight'?1:-1);}});
    let frame;rail.addEventListener('scroll',()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(update);},{passive:true});
    window.addEventListener('resize',update,{passive:true});mobile.addEventListener('change',update);
    if(typeof ResizeObserver!=='undefined')new ResizeObserver(update).observe(rail);
    update();
  }
  function initialize(){document.querySelectorAll('[data-lc-c70-wearing]').forEach(setup);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize,{once:true});else initialize();
  document.addEventListener('shopify:section:load',initialize);
  document.addEventListener('click',event=>{
    const trigger=event.target instanceof Element?event.target.closest('[data-lc-c70-chat]'):null;
    if(!trigger||event.defaultPrevented||event.button>0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
    const chat=document.querySelector('shopify-chat');
    if(chat?.hasAttribute('open')){event.preventDefault();return;}
    const activator=chat?.shadowRoot?.querySelector('button[part="activator"]');
    if(!activator)return;
    event.preventDefault();if(activator.getAttribute('aria-expanded')!=='true')activator.click();
  });
})();
